import Product from './product';

const Products = ({ products }) => {
  const productsRender = (
    <div className='products-container'>
      {products.map((product) => {
        return (
          <Product
            image={product.images}
            name={product.name}
            description={product.description}
            price={product.prices[0].unit_amount / 100}
            priceid={product.default_price}
            key={product.id}
            category={product.metadata.category}
          />
        );
      })}
    </div>
  );
  return productsRender;
};

export default Products;
